// extracted by mini-css-extract-plugin
module.exports = {"contentInput":"TextArea_contentInput__29iFZ","description":"TextArea_description__1Ri1F","labelInput":"TextArea_labelInput__2Jpqp","errorInput":"TextArea_errorInput__3EKJV"};